import { StreamType } from '@wix/da-shared-react/pkg/Stream';
import { fetchNextMyLibrary } from './redux/actions';
export const PREVIEW_BASE_URL = 'https://st.deviantart.net/muro/brush_previews/';
export const CACHE_BUSTER = '2';
export const i18nNamespace = 'muro';
export const MURO_COMMENTS_FOLDER_NAME = 'Comments creations';
export const MURO_LIBRARY_STREAM = {
    streamId: 'MURO_MY_LIBRARY_STREAM',
    streamConfig: {
        autoFetch: false,
        itemsPerFetch: 50,
        streamType: StreamType.WITH_OFFSET,
        fetchNextCallback: fetchNextMyLibrary
    },
    papiEndpointUrl: '/gallection/contents'
};

//# sourceMappingURL=constants.js.map